
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center">
                <i className="ri-book-open-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold text-emerald-600" style={{ fontFamily: '"Pacifico", serif' }}>
                MathLish
              </span>
            </Link>
            <p className="text-gray-600 mb-4 max-w-md">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center text-white transition-all duration-300 ease-in-out social-button hover-effect"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center text-white transition-all duration-300 ease-in-out social-button hover-effect"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center text-white transition-all duration-300 ease-in-out social-button hover-effect"
              >
                <i className="ri-youtube-line"></i>
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-emerald-600 rounded-lg flex items-center justify-center text-white transition-all duration-300 ease-in-out social-button hover-effect"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-600 hover:text-emerald-600 transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/courses" className="text-gray-600 hover:text-emerald-600 transition-colors">{t('nav.courses')}</Link></li>
              <li><Link to="/wall-of-fame" className="text-gray-600 hover:text-emerald-600 transition-colors">{t('nav.wallOfFame')}</Link></li>
              <li><Link to="/work-with-us" className="text-gray-600 hover:text-emerald-600 transition-colors">{t('nav.workWithUs')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('footer.contact')}</h3>
            <div className="space-y-2">
              <p className="text-gray-600 flex items-center">
                <i className="ri-mail-line mr-2"></i>
                info@mathlish.aarivian.com
              </p>
              <p className="text-gray-600 flex items-center">
                <i className="ri-phone-line mr-2"></i>
                +380 672954498
              </p>
              <p className="text-gray-600 flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                {t('footer.location')}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
          © {new Date().getFullYear()} Mathlish. Powered by Aarivian. 📞 +34 603294146
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-emerald-600 hover:text-emerald-700 text-sm font-medium transition-colors mt-2 md:mt-0 footer-button hover-effect"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
